import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Bugraphs } from "../components/Builders/Bugrafx/Bugraphs";
import { getDataUser, setTemporalUsers } from "../libs/redux/slices/authSlice/authSlice";
import { useGetUserTemporalQuery, useGetDashboardQuery, useGetTurnsTodayByUserQuery } from "../libs/redux/slices/authSlice/authApiSlice";
import { BoxStatus, ShiftBanner, Box } from "codekit";
import { Avisoxxx, useDrilldown } from "../components/Tablerox";
import { setInitialFilter } from "../libs/redux/slices/Graficsx/Criticid/criticidSlice";
import { useGetQuantityCriticalQuery } from "../libs/redux/slices/Graficsx/Criticid/criticidApiSlice";
import { Buttonsx, Galerdas } from "../components/Dashboax";
import { useGetVisiblesQuery } from "../libs/redux/slices/Paramgen/Dashestx/dashestxApiSlice";

function DashboardHome() {
  const dispatch = useDispatch();
  const [currentView, setCurrentView] = useState("HOME");
  const { USRIDXXX, CARIDXXX, USRNOMXX } = useSelector(getDataUser);
  //Los tableros estaticos del cargo (CIMS0118). RTK Query cachea la respuesta, asi que Galerdas
  //reusa esta misma consulta y no se pide dos veces.
  const { data: visibles, isLoading: isLoadingVisibles } = useGetVisiblesQuery();
  const { data: turnsByUser } = useGetTurnsTodayByUserQuery({ USRIDXXX });
  const { data: temporalUsers, isSuccess } = useGetUserTemporalQuery({ USRIDXXX });
  const [banner, setBanner] = React.useState(null);
  const { data: dataGraphics, isSuccess: isSuccessGraphics } = useGetDashboardQuery();
  const graphicsTurn = ["NOTITURN"];
  //El aviso de operaciones críticas se cierra por sesión y por cantidad: si cambia el número, vuelve a salir
  const [avisoCerrado, setAvisoCerrado] = useState(() => window.sessionStorage.getItem("aviso-criticas-cerrado"));
  const { ir, filtroIn } = useDrilldown();
  const criticidRef = useRef(null);
  const [isCritical, setIsCritical] = useState(false)
  const { data: criticalOperations, isSuccess: isSuiccessCritical } = useGetQuantityCriticalQuery(
    {},
    { refetchOnMountOrArgChange: true },
  );
  const [quantityCritical, setQuantityCritical] = useState(0)

  const toDateAt = (dateStr, timeStr) => new Date(`${dateStr}T${timeStr}`);

  const fmtHour = (d) =>
    d.toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit', hour12: true });


  //Hook para el seteo de los usuarios reemplazo
  useEffect(() => {
    if (isSuccess) {
      const { data = [] } = temporalUsers;
      dispatch(setTemporalUsers(data));
    }
  }, [isSuccess, temporalUsers, dispatch]);

  //Hook para validar si se encontraron operaciones criticas
  useEffect(() => {
    if (isSuiccessCritical) {
      const { data = {} } = criticalOperations;
      if (Object.keys(data).length > 0) {
        setIsCritical(true)
        setQuantityCritical(data["ROJO"].total)
      }
    }
  }, [isSuiccessCritical, criticalOperations])

  React.useEffect(() => {
    const compute = () => {
      const dayData = turnsByUser?.data;
      const turns = dayData?.TURNSXXX ?? [];

      if (!Array.isArray(turns) || turns.length === 0) {
        setBanner({ visible: false, variant: 'start', primary: '', secondary: '' });
        return;
      }

      const dateStr = dayData.DATEXXXX;

      const ranges = turns
        .flatMap(t => (t.RANGESXX ?? []).map(r => ({
          start: toDateAt(dateStr, r.STARTXXX),
          end: toDateAt(dateStr, r.ENDXXXXX),
        })))
        .sort((a, b) => a.start - b.start);

      const now = new Date();

      const current = ranges.find(r => now >= r.start && now < r.end);
      if (current) {
        setBanner({
          visible: true,
          variant: 'end',
          primary: `Tu turno termina a las ${fmtHour(current.end)}`,
          secondary: 'Recuerda finalizar tu turno en la opción Cerrar Turno',
        });
        return;
      }

      const next = ranges.find(r => now < r.start);
      if (next) {
        setBanner({
          visible: true,
          variant: 'start',
          primary: `Tu turno inicia a las ${fmtHour(next.start)}`,
          secondary: `Hoy (${dayData.DAYXXXXX}). Recuerda finalizar tu turno en la opción Cerrar Turno`,
        });
        return;
      }

      setBanner({ visible: false, variant: 'start', primary: '', secondary: '' });
    };

    compute();
    const id = setInterval(compute, 5 * 60 * 1000); // 5 minutos
    return () => clearInterval(id);
  }, [turnsByUser]);

  //Se espera tambien a los tableros para que la barra de pestañas no aparezca a medias
  if (!isSuccessGraphics || isLoadingVisibles) {
    return <BoxStatus variant="loading" text="Cargando información..." />;
  }
  //Una sola fuente (FASE 5, root/cimaapi#355; kit 2026-09-14): los widgets del
  //Inicio son los del catalogo asignados al cargo (CIMS0037 → CIMS0036) y se
  //pintan con la misma tarjeta de Mi escritorio. Registrar un widget nuevo es
  //un INSERT — el front ya no opina.
  const hasTurns = dataGraphics.data.some(
    (item) => graphicsTurn.includes(item.GRACOMXX)
  );

  //Que pestañas se ven depende de lo que el cargo tenga asignado, no de una lista de cargos en el
  //codigo: HOME sale de la parametrica de graficas (CIMS0037) y TABLEROS de la de tableros
  //estaticos (CIMS0118). Con una sola de las dos la barra no aporta nada y se entra directo.
  const hasGraficas = dataGraphics.data.length > 0;
  const hasTableros = (visibles?.data?.length ?? 0) > 0;
  const showTabs = hasGraficas && hasTableros;
  const currentTab = showTabs ? currentView : hasTableros ? "TABLEROS" : "HOME";

  //Aviso de operaciones críticas (kit): al tablero de criticidad si el cargo lo tiene, o al tracking
  const tieneCriticid = dataGraphics.data.some((g) => g.GRACOMXX === "CRITICID");
  const handleVerTablero = (color) => {
    dispatch(setInitialFilter(color));
    setTimeout(() => criticidRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 300);
  };
  const handleAbrirTracking = (color) => ir("Modimpxx", "Trackimp", [filtroIn("MDOSYYYY.REGESTXX", "ACTIVO"), filtroIn("MDSSYYYY.COLORXXX", color)]);
  const handleCerrarAviso = () => {
    window.sessionStorage.setItem("aviso-criticas-cerrado", String(quantityCritical));
    setAvisoCerrado(String(quantityCritical));
  };

  return (
    <>
      {/**Operaciones críticas: aviso del kit en vez del modal que tapaba la pantalla (Diego 2026-09-14) */}
      {isCritical && quantityCritical > 0 && avisoCerrado !== String(quantityCritical) && (
        <Box mb={4}>
          <Avisoxxx
            tonoxxx="ROJO"
            kicker={`Bienvenid@ ${USRNOMXX}`}
            valor={quantityCritical}
            titulo={quantityCritical === 1 ? "operación crítica en tu perfil" : "operaciones críticas en tu perfil"}
            texto="Ya incumplen o están al borde de sus términos. Cada número abre su pantalla."
            acciones={[
              { clave: "tracking", texto: "Abrir en el tracking", primaria: true, onClick: () => handleAbrirTracking("ROJO") },
              ...(tieneCriticid ? [{ clave: "tablero", texto: "Ver en el tablero", onClick: () => handleVerTablero("ROJO") }] : []),
            ]}
            onCerrar={handleCerrarAviso}
          />
        </Box>
      )}
      {showTabs && <Buttonsx currentView={currentTab} handleCurrentView={setCurrentView} />}
      {hasGraficas && (
        <Box style={{ display: currentTab === "HOME" ? "block" : "none" }}>
          {hasTurns && banner?.visible && (
            <Box spacing={5}>
              <ShiftBanner
                variant={banner.variant}
                srcBgImage="/images/cima-icon.png"
                primaryText={banner.primary}
                secondaryText={banner.secondary}
                alignment="left"
                imageRotation={-10}
                imageX={95}
              />
            </Box>
          )}
          <Bugraphs graphs={dataGraphics.data} refs={{ CRITICID: criticidRef }} />
        </Box>
      )}
      {hasTableros && currentTab === "TABLEROS" && <Galerdas />}
    </>
  );
}

export default DashboardHome;
